import { Clock, CheckCircle2, XCircle, Lock } from "lucide-react";

export const STATUS = {
  pending: { icon: Clock, label: "Pending approval", cls: "text-amber-500", text: "Your ID is ready. Our team will reach out for payment. Courses and your partner link unlock once it's approved." },
  approved: { icon: CheckCircle2, label: "Active", cls: "text-emerald-500", text: "Your ID is active. Keep learning and share your link to grow your team." },
  rejected: { icon: XCircle, label: "Not approved", cls: "text-red-500", text: "Your ID could not be approved. Please reach out through Help & Support." },
  paid: { icon: CheckCircle2, label: "Paid", cls: "text-emerald-500" },
  unpaid: { icon: Clock, label: "Unpaid", cls: "text-amber-500" },
};

export const StatusPill = ({ status }) => {
  const s = STATUS[status] || STATUS.pending;
  return <span data-testid={`status-${status}`} className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-bold glass ${s.cls}`}><s.icon size={13} /> {s.label}</span>;
};

export const Locked = ({ text = "This section unlocks after your ID is approved." }) => (
  <div data-testid="locked-panel" className="glass rounded-3xl p-10 text-center">
    <div className="icon-orb mx-auto"><Lock size={20} /></div>
    <p className="text-sm text-[var(--muted)] mt-4">{text}</p>
  </div>
);

export const Card = ({ children, className = "", ...rest }) => <div className={`glass rounded-3xl p-6 sm:p-7 ${className}`} {...rest}>{children}</div>;

export const PageHead = ({ title, highlight, sub }) => (
  <div className="mb-8">
    <h1 className="font-display text-3xl sm:text-4xl font-bold">{title} <span className="neon-text">{highlight}</span></h1>
    {sub && <p className="text-sm text-[var(--muted)] mt-2">{sub}</p>}
  </div>
);

export const Stat = ({ label, value, testid }) => (
  <div data-testid={testid} className="rounded-2xl border border-[var(--surface-border)] p-5 text-center">
    <p className="font-display text-3xl font-bold neon-text">{value}</p>
    <p className="text-xs text-[var(--muted)] mt-1">{label}</p>
  </div>
);
